import Model, { ID, IsoDateTime, JsonObject, MODEL_LEVEL } from 'src/models/model'
import User from 'src/models/user/User'

export default class FormEntry extends Model {
  static name = 'FormEntry'

  static deletable = true

  static paginate = true

  static level = MODEL_LEVEL.SITE

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Marketing]

  static define () {
    this.fields = {
      id: {
        type: ID,
        required: true
      },
      name: {
        type: String,
        required: true
      },
      subject: {
        type: String
      },
      senderName: {
        type: String
      },
      notifyEmail: {
        type: String
      },
      submissionEmail: {
        type: String
      },
      values: {
        type: JsonObject
      },
      user: {
        type: User,
        output: true
      },
      createdAt: {
        type: IsoDateTime,
        output: true
      }
    }
  }
}
